export default __webpack_public_path__ + "static/media/ic_filter.a78bafbb.svg";